import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledAlertMessage = styled(Text)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;

        & svg {
            width: inherit;
            height: inherit;
        }
    `
)

export const StyledAlertMessageIcon = styled.span<{$size?: number}>(
    ({$size = 16}) => css`
        width: ${$size}px;
        height: ${$size}px;
    `
)
